import { calculatePriceWithOptions } from 'core/lib'

const initialState = {
	open: false,
	products: [],
	total: 0,
}

// REDUCERS
export const reducer = (state = initialState, action) => {
	const getTotal = (products) => {
		let total = 0
		products.forEach(product => {
			total = total + product.price * product.quantity
		})
		return total
	}
	switch (action.type) {
		case 'addProduct@cart': {
			const key = action.product.key
			let newArray = state.products
			if (newArray.filter(product => product.key == key).length > 0) {
				// prodotto già nel carrello, aggiorno la quantità
				newArray.forEach(product => {
					if (product.key == key) {
						product.quantity = product.quantity + action.quantity
						// Se ho una quantità massima disponibile verifico di non averla superata
						if (!!action.availableQuantity && product.quantity > action.availableQuantity) {
							product.quantity = Number(action.availableQuantity)
						}
					}
				})
			} else {
				// prodotto non nel carrello, lo aggiungo
				newArray = [
					...state.products,
					{
						key: key,
						...action.product,
						availableQuantity: action.product.quantity,
						quantity: action.quantity,
					}
				]
			}
			return {
				...state,
				products: newArray,
				total: getTotal(newArray),
			}
		}

		case 'updateQuantity@cart': {
			const key = action.product.key
			let newArray = state.products
			if (newArray.filter(product => product.key == key).length > 0) {
				newArray.forEach(product => {
					if (product.key == key) {
						product.quantity = action.quantity
					}
				})
			}
			return {
				...state,
				products: newArray,
				total: getTotal(newArray),
			}
		}

		case 'check@cart': {
			const itemIds = action.cart.map(p => p.item_id)
			let newArray = []
			// Scorro il carrello
			state.products.forEach(product => {
				if (String(product.key).slice(0, 12) == 'reservation_') {
					// Se è un prodotto di tipo prenotazione lo lascio invariato
					newArray.push(product)
				} else {
					const itemId = product.item_id

					// Verifico se il prodotto esiste ancora dopo il check
					if (itemIds.includes(itemId)) {
						// Sostituisco i dati del prodotto nel carrello con quello ottenuto dal check per aggiornare eventuali dati
						let newProduct = action.cart.filter(p => p.item_id == itemId)[0]
						const newQuantity = action.checkQuantity
							? product.quantity > newProduct.quantity ? Number(newProduct.quantity) : Number(product.quantity)
							: Number(product.quantity)
						newProduct = {
							...newProduct,
							availableQuantity: newProduct.quantity,
							key: product.key,
							options: product.options,
							quantity: newQuantity,
						}
						newArray.push({
							...newProduct,
							price: calculatePriceWithOptions(newProduct)
						})
					}
				}
			})
			return {
				...state,
				products: newArray,
				total: getTotal(newArray),
			}
		}

		case 'removeProduct@cart': {
			const key = action.product.key
			let newArray = state.products.filter(product => product.key != key)
			return {
				...state,
				products: newArray,
				total: getTotal(newArray),
			}
		}

		case 'removeAll@cart': {
			return {
				...state,
				products: [],
				total: 0,
			}
		}

		case 'toggle@cart': {
			return {
				...state,
				open: action.openState
			}
		}

		default: return state
	}
}
